import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
  ActivityIndicator,
} from "react-native";

import { NavigationActions, StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputLayout from "../components/InputLayout";
import ButtonLayout from "../components/ButtonLayout";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";
import Joi from "react-native-joi";
import makeRequest from "../components/makeRequest";
import * as WebBrowser from "expo-web-browser";

export default function (props) {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [isFailed, setFailed] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");

  const [isLoading, setLoading] = useState(false);
  const _handleOpenWithWebBrowser = () => {
    WebBrowser.openBrowserAsync("http://appcitaprevia.com/terminos.pdf");
  };

  const tryRegister = async () => {
    let response;
    if (password !== repeatPassword) {
      setFailed(true);
      setPassword("");
      setRepeatPassword("");
      setFailureMessage("Las contraseñas no coinciden");
      return;
    }
    if (
      nombre.trim() == "" ||
      apellido.trim() == "" ||
      email.trim() == "" ||
      telefono.trim() == "" ||
      password.trim() == ""
    ) {
      setFailed(true);
      setFailureMessage("Todos los campos son obligatorios");
      return;
    }
    setLoading(true);
    response = await makeRequest("users", "post", {
      nombre: nombre,
      apellido: apellido,
      email: email,
      telefono: telefono,
      password: password,
    });
    if (response[0] === 200) {
      props.navigation.dispatch(StackActions.replace("CodigoSMS"));
    } else {
      console.log(response[0]);
      setFailed(true);
      setFailureMessage("Ha ocurrido un error en su solicitud");
      setLoading(false);
    }
  };
  return (
    <BackgroundUser scroll={true}>
      <Logo></Logo>
      <View style={{ marginTop: 50, alignItems: "center" }}>
        <Title style={{ marginTop: -10, fontWeight: "bold" }}>Registro</Title>
        <InputLayout
          placeholder='Nombre'
          schema={Joi.string()
            .min(3)
            .max(150)
            .regex(/[A-z]./)
            .required()}
          errorMessage='Inserte un nombre válido'
          value={nombre}
          onChangeText={setNombre}
        />
        <InputLayout
          placeholder='Apellido'
          schema={Joi.string()
            .min(3)
            .max(150)
            .regex(/[A-z]./)
            .required()}
          errorMessage='Inserte un apellido válido'
          value={apellido}
          onChangeText={setApellido}
        />
        <InputLayout
          placeholder='Contraseña'
          schema={Joi.string().min(6).max(150).required()}
          errorMessage='Contraseña no válida'
          secureTextEntry={true}
          value={password}
          onChangeText={setPassword}
        />
        <InputLayout
          placeholder='Repetir Contraseña'
          secureTextEntry={true}
          value={repeatPassword}
          onChangeText={setRepeatPassword}
        />
        <InputLayout
          placeholder='Correo electrónico'
          schema={Joi.string()
            .regex(/^\w+@.+?\.[a-zA-Z]{2,3}$/)
            .min(1)
            .max(255)
            .required()}
          errorMessage='Inserte un correo válido'
          value={email}
          onChangeText={(text) => setEmail(text.trim())}
        />
        <InputLayout
          placeholder='Teléfono móvil'
          schema={Joi.string()
            .regex(/^(6|7)[0-9]{8}$/)
            .max(9)
            .required()}
          keyboardType='number-pad'
          errorMessage='Inserte un número válido'
          value={telefono}
          onChangeText={(text) => setTelefono(text.trim())}
        />
        {isLoading && <ActivityIndicator color='white' size='large' />}
        {isFailed && !isLoading && (
          <Text style={{ color: "red", textAlign: "center" }}>
            {failureMessage}
          </Text>
        )}
        <Title style={{ fontSize: 16 }}>
          Al pulsar Registrarme aceptas los{" "}
        </Title>
        <TouchableOpacity onPress={_handleOpenWithWebBrowser}>
          <Title
            style={{
              fontSize: 16,
              textDecorationLine: "underline",
              textDecorationStyle: "solid",
              textDecorationColor: "#3E4672",
            }}>
            Términos y Condiciones de Uso
          </Title>
        </TouchableOpacity>
        <ButtonLayout text='Registrarme' onPress={tryRegister}></ButtonLayout>
        <ButtonLayoutMenu
          text='Cancelar'
          style={{ maxWidth: 150 }}
          onPress={() =>
            props.navigation.dispatch(StackActions.replace("UserLogin"))
          }></ButtonLayoutMenu>

        <View style={{ height: 50 }}></View>
      </View>
    </BackgroundUser>
  );
}
